import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const erasmusMobilityTypesApi = createApi({
  reducerPath: 'erasmusMobilityTypesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getErasmusMobilityTypes: builder.query({
      query: (isEnglish = false) => {
        return {
          url: urls.erasmusMobilityTypes,
        };
      },
    }),
    getErasmusMobilityType: builder.query({
      query: (id) => ({
        url: urls.erasmusMobilityTypeDetail(id),
      }),
    }),
    saveErasmusMobilityType: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.erasmusMobilityTypeDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.erasmusMobilityTypes,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteErasmusMobilityType: builder.mutation({
      query(id) {
        return {
          url: urls.erasmusMobilityTypeDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetErasmusMobilityTypesQuery,
  useGetErasmusMobilityTypeQuery,
  useSaveErasmusMobilityTypeMutation,
  useDeleteErasmusMobilityTypeMutation,
} = erasmusMobilityTypesApi;
